/**
 * Functions to hook Google Analytics events to on page actions
 */

/* global gtag */
/* global gaVars */
/* exported handleRender, gtagEvent, gtagEventHandler */

jQuery(document).ready(function ($) {
    if ((typeof gaVars === 'object')) {
        $('a[href*=".pdf"]').click(function () {
            setTagEvent($(this), "PDFs");
        });

        $('a[href*=".docx"]').click(function () {
            setTagEvent($(this), "DOCXs");
        });

        $('a.ga-event').click(function () {
            var slug = gaVars.baseUrl;
            if (gaVars.baseUrl !== gaVars.pageUrl) {
                slug = gaVars.pageUrl.replace(gaVars.baseUrl, '');
            }
            var eventAction = $(this).attr('data-ga-action');
            var eventCategory = $(this).attr('data-ga-category');
            gtagEvent(eventCategory, eventAction, slug);
        });

        //fires event when search page loads
        $(document).ready(function () {
            if ($("#bocss-search__input").length > 0) {
                var results = filtersUrlParams();
                var previousPage = document.referrer;
                var bUrl = gaVars.baseUrl;


                if (previousPage.startsWith(bUrl)) {
                    previousPage = previousPage.replace(bUrl, "");
                    if (previousPage === '') {
                        previousPage = '/';
                    }
                }

                gtag('event', "view_search_results", {
                    'search_term': results['search_term'],
                    'previous_page': previousPage
                });
            }
        });

        //sends event to ga4 when there is a change in filters or in the search bar
        $('body').on('change', '.ga-event-filter', function (event) {
            $('#bocss-search__input').ready(function () {

                var results = filtersUrlParams();
                results['search_filter_triggered'] = event.target.name;
                gtag('event', "view_search_results", results);
            });

        });

        // Prevent OutBound links events firing duplicate events if they are social, PDF links, or DOCX links
        $('a').not('.ga-event').not('a[href*=".pdf"]').not('a[href*=".docx"]').not('.social-icons a').not('.clickable-row').on('click', function () {
            var domainsString = gaVars.domains.join('|').replace(/\./g, '\\.');
            var matchDomain = new RegExp('^(http(s)?:)?\/\/(www.)?(' + domainsString + ')', 'i');
            if ((this.href + "").match(matchDomain)) {
                return;
            }
            var txt = $.trim($(this).text());
            gtagEvent('Outbound Links', gaVars.pageUrl, (txt || 'IMAGE') + ' - ' + this.href);
        });

        $(".lang-analytics").click(function () {
            gtagEvent('Language switch', gaVars.pageUrl);
        });
        $(document).on('click', 'li.amcharts-ga-event', function (event) {
            var slug = gaVars.baseUrl;
            if (gaVars.baseUrl !== gaVars.pageUrl) {
                slug = gaVars.pageUrl.replace(gaVars.baseUrl, '');
            }
            //navigates to the main div and gets the ID
            var chartID = $(this).parents('div.amcharts-main-div').parent().attr('id');
            //create complete event description
            var eventAction = window[chartID]['titles'][0]['text'] + ' ' + event.target.innerText;
            var eventCategory = 'AmCharts';
            gtagEvent(eventCategory, eventAction, slug);
        });
    }
});

/**
 * function to send a GA event when an AmChart has been rendered
 * @param {object} event     The AMChart render event
 * @returns {void}
 */
function handleRender(event) {
    if ((typeof gaVars === 'object')) {
        var slug = gaVars.baseUrl;
        if (gaVars.baseUrl !== gaVars.pageUrl) {
            slug = gaVars.pageUrl.replace(gaVars.baseUrl, '');
        }

        var chartTitle = '';
        if (event.chart.titles.length > 0) {
            chartTitle = event['chart']['titles'][0]['text'];
        } else {
            chartTitle = 'no title';
        }
        var eventAction = chartTitle + ' View';
        var eventCategory = 'AmCharts';
        gtagEvent(eventCategory, eventAction, slug);
    }
}

/**
 * function to send a GA event
 * @param {string} eventCategory Category
 * @param {string} eventAction Action
 * @param {string} eventLabel Label (optional)
 * @returns {void}
 */
function gtagEvent(eventCategory, eventAction, eventLabel) {
    if (typeof gaVars === 'object' && typeof window.dataLayer === 'object') {
        if (localStorage.getItem('_bocDebug')) {
            // eslint-disable-next-line no-console
            console.log("Category:", eventCategory, "\n  Action:", eventAction, "\n   Label:", eventLabel);
        }
        if (eventLabel === null) {
            gtag('event', eventAction, {
                'event_category': eventCategory
            });
        } else {
            gtag('event', eventAction, {
                'event_category': eventCategory,
                'event_label': eventLabel
            });
        }
    }
}

/**
 * function to send a GA event
 * @param {object} data Category
 * @returns {void}
 */
function gtagEventHandler(data) {
    gtagEvent(data.eventCategory, data.eventAction, data.eventLabel);
}

/**
 * function to set up the tag event and call it
 * @param {object} element DOM element containing metadata
 * @param {string} eventCategory the name of the event category
 * @returns {void}
 * */
function setTagEvent(element, eventCategory) {
    var filePath = element.text() + ' ~~ ' + element.attr('href').replace(gaVars.baseUrl, '');
    var contentType = 'Uncategorized - ' + gaVars.activeLang;
    if (typeof element.attr('data-content-type') !== 'undefined') {
        contentType = element.attr('data-content-type');
    }
    gtagEvent(eventCategory, contentType, filePath);
}

/**
 * function that finds the value of the filter(s) used from the url and saves it in results.
 * @returns {object} results
 **/
function filtersUrlParams() {
    var queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    var trackedTerms = {
        'q_topic': 'topic[]',
        'q_content_type': 'content_type[]',
        'q_jel': 'jel[]',
        'q_location': 'location[]',
        'q_department': 'department[]',
        'q_profile_post': 'profile_post[]',
        'q_source': 'source[]',
        'q_statuses': 'statuses[]',
        'q_mtf_date_after': 'mtf_date_after',
        'q_mtf_date_before': 'mtf_date_before',
        'search_term': 'esearch'
    };

    var results = {};
    for (var prop in trackedTerms) {
        for (var key of urlParams.keys()) {
            if (key === trackedTerms[prop] && urlParams.getAll(key).toString() !== '') {
                results[prop] = urlParams.getAll(key).toString();
            }
        }
    }
    return results;
}
